import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	ariaLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.group.aggregate-field.dependencies-cell.flyout.aria-label',
		defaultMessage: 'Open issue {fullIssueKey} in new window',
		description: 'Text for issue link',
	},
});
